"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class TerminalService {
    constructor(baseApiPath) {
        this.baseApiPath = baseApiPath;
    }
    fetchOnlineTerminal(terminalOnlineFetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}business/terminal/online/list?page=${terminalOnlineFetchPayload.pageNumber}&limit=${terminalOnlineFetchPayload.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respData = response.data.data;
                return respData;
            }
            catch (error) {
                throw new Error('Error in fetching terminal online');
            }
        });
    }
    createOnlineTerminal(terminalOnlineCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}business/terminal/online/create`;
                terminalOnlineCreatePayload = JSONbig.stringify(terminalOnlineCreatePayload);
                const response = yield axios_1.default.post(url, terminalOnlineCreatePayload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                return response.data.message;
            }
            catch (error) {
                throw new Error('Error in creating terminal online');
            }
        });
    }
    fetchOfflineTerminal(terminalOfflineFetchPayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}business/terminal/offline/list?page=${terminalOfflineFetchPayload.pageNumber}&limit=${terminalOfflineFetchPayload.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const responseData = response.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error('Error in fetching terminal offline list');
            }
        });
    }
    createOfflineTerminal(terminalOfflineCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}business/terminal/offline/create`;
                terminalOfflineCreatePayload = JSONbig.stringify(terminalOfflineCreatePayload);
                const response = yield axios_1.default.post(url, terminalOfflineCreatePayload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error('Error in creating terminal offline');
            }
        });
    }
    updateTerminal(terminalOfflineCreatePayload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = `${this.baseApiPath}business/terminal/edit`;
                terminalOfflineCreatePayload = JSONbig.stringify(terminalOfflineCreatePayload);
                const response = yield axios_1.default.put(url, terminalOfflineCreatePayload, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (error) {
                throw new Error(error);
            }
        });
    }
    createHostTerminal(hostTerminalCreateData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                hostTerminalCreateData = JSONbig.stringify(hostTerminalCreateData);
                let url = `${this.baseApiPath}business/terminal/offline/host/create`;
                const response = yield axios_1.default.post(url, hostTerminalCreateData, {
                    transformResponse: [
                        (data, headers) => JSONbig.parse(data),
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const responseData = response.data.message;
                return responseData;
            }
            catch (err) {
                throw err.response.data.message;
            }
        });
    }
}
exports.TerminalService = TerminalService;
